import React, { Fragment } from 'react';
import { string } from 'prop-types';
import Head from 'next/head';
import { DOMParser } from 'util/dom';
import styles from './styles';

function AmpCerosEmbed({ raw }) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(raw, 'text/html');
  let src;
  if (doc) {
    const iframeDiv = doc
      .getElementsByTagName('section')[0]
      .getElementsByTagName('div')[0];

    src =
      iframeDiv.getAttribute('data-sm-src') ||
      iframeDiv.getAttribute('data-lg-src');
  }
  return (
    <Fragment>
      <style jsx>{styles}</style>
      <Head>
        <script
          async
          custom-element="amp-iframe"
          key="amp-iframe"
          src="https://cdn.ampproject.org/v0/amp-iframe-0.1.js"
        />
      </Head>
      <amp-iframe
        className="CerosEmbed"
        src={`https:${src}`}
        layout="responsive"
        width={300}
        height={300}
        sandbox="allow-scripts allow-same-origin allow-popups"
      >
        <amp-img
          layout="fill"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
          placeholder
        />
      </amp-iframe>
    </Fragment>
  );
}

AmpCerosEmbed.propTypes = {
  raw: string
};

AmpCerosEmbed.defaultProps = {
  raw: null
};

export default AmpCerosEmbed;
